import React, { DetailedHTMLProps, forwardRef, HTMLAttributes, useMemo } from 'react'
import block from 'bem-cn'

import { ICONS, IconTypes } from './types'

import './Icon.scss'

export enum IconSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export type IconProps = DetailedHTMLProps<HTMLAttributes<SVGSVGElement>, SVGSVGElement> & {
  type: IconTypes
  size?: IconSize | number
}
type CSSVariables = {
  '--icon-size'?: string
}

type CustomStyle = React.CSSProperties & CSSVariables

const b = block('icon')

export const Icon = forwardRef<SVGSVGElement, IconProps>(
  ({ type, size = IconSize.MEDIUM, className, ...props }, ref) => {
    const styles = useMemo(() => {
      let sizeStyles: undefined | CustomStyle

      if (Number.isFinite(size)) {
        sizeStyles = { '--icon-size': `${size}px` }
      }

      return sizeStyles ? { ...sizeStyles, ...props.style } : props.style
    }, [props.style, size])

    const IconSVG = useMemo(() => ICONS[type], [type])

    const formattedSize = useMemo(() => {
      if (typeof size === 'string') {
        return size
      }

      return undefined
    }, [size])

    if (!IconSVG) {
      return null
    }

    return <IconSVG className={b({ size: formattedSize }).mix(className)} style={styles} {...props} />
  },
)

Icon.displayName = 'Icon'
